import { render } from "./IssueMessage.vue?vue&type=template&id=44b20232&bindings={\"issue\":\"props\",\"ago\":\"data\",\"issues\":\"options\",\"issueHelp\":\"options\"}"
import script from "./IssueMessage.vue?vue&type=script&lang=js"
export * from "./IssueMessage.vue?vue&type=script&lang=js"
script.render = render

export default script